import React from "react";
import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import Grid from "@material-ui/core/Grid";
import {Input} from "@material-ui/core";


export function SymbolsLeftTextFields({symbolsLeft, symbolsUsed}) {
    return <Grid item container>
        <Grid item xs={4}>
            <Input
                readOnly
                style={{fontSize: 11, backgroundColor: "white"}}
                value={"used: "+symbolsUsed}
            />
        </Grid>
        <Grid item xs={8}>
            <Input
                readOnly
                style={{fontSize: 11, backgroundColor: "white"}}
                value={"symbolsLeft: "+symbolsLeft}
            />
        </Grid>
    </Grid>
}
/*

export default class AgSymbolsLeft extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columnNames: [
                {
                    headerName: "symbolsUsed",
                    field: "symbolsUsed",
                    resizable: true,
                },
                {
                    headerName: "symbolsLeft",
                    field: "symbolsLeft",
                    resizable: true,
                },
            ],
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridColumnApi = params.columnApi;
        var allColIds = params.columnApi
            .getAllColumns()
            .map((column) => column.colId);
        params.columnApi.autoSizeColumns(allColIds);

        // If you want to resize all columns
        //params.columnApi.autoSizeAllColumns();
    };

    render() {
        let row = [
            {
                symbolsUsed: this.props.symbolsUsed,
                symbolsLeft: this.props.symbolsLeft,
            },
        ];
        if (this.refs.agGrid !== undefined) {
            this.refs.agGrid.api.refreshCells();
        }
        return (
            <div className="ag-theme-balham-dark"
                 style={{width: "75%", height: "60", overflow: "hidden", fontSize: 8}}>
                <AgGridReact
                    ref="agGrid" // useful for accessing the component directly via ref
                    //gridAutoHeight={true}
                    domLayout="print"
                    columnDefs={this.state.columnNames}
                    rowData={row}
                    onGridReady={this.onGridReady.bind(this)}
                />
            </div>
        );
    }
}
*/
